<!-- 予約済みチケット購入 -->
<template>
  <TemplateMfittMyTicketPurchase v-if="isReadyToDraw" />
  <DialogInitialLoading v-else :timeout-seconds="21000" />
</template>

<script>
import TemplateMfittMyTicketPurchase from "@/views/Templates/MFITT/TemplateMfittMyTicketPurchase";
import { onMounted, ref } from "vue";
import API from "../../../API";

export default {
  name: "MfittMyTicketPurchase",
  components: {
    TemplateMfittMyTicketPurchase,
  },
  setup() {
    const isReadyToDraw = ref(false);

    onMounted(async () => {
      await API.getTicketPriceForReserved();
      isReadyToDraw.value = true;
    });

    return {
      isReadyToDraw,
    };
  },
};
</script>
